import type { MutationFunction } from "@tanstack/react-query";
import { type HTTPResponse, useHTTP, useHTTPEnvironment, useHTTPMutation } from "@/lib/http";

export interface LoginRequestModel {
	readonly emailAddress: string;
	readonly password: string;
	readonly mfaCode: string | null;
}

export type LoginResponseModel = {
	readonly emailVerified: false;
} | {
	readonly emailVerified: true;
	readonly accessToken: string | null;
};

export const useLogin = () => {
	const http = useHTTP("None");
	const httpEnvironment = useHTTPEnvironment();

	const mutationFn: MutationFunction<HTTPResponse<LoginResponseModel>, LoginRequestModel> = requestModel => {
		return http<LoginResponseModel, LoginRequestModel>({
			method: "POST",
			url: "/auth/login",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: data => {
			if (!data.body.emailVerified || !data.body.accessToken) {
				return;
			}

			httpEnvironment.setAccessToken(data.body.accessToken);
		}
	});
};
